import { DroppedImage } from "@lib/store/src/mark";
import styles from "./mark-modals.styles.css";
import { setImageComment } from "../utils/image-tools";
import i18next from "i18next";
export class CommentModal {
  private modal: HTMLDivElement;
  private textarea: HTMLTextAreaElement;
  private okButton: HTMLButtonElement;
  private initialText: string;
  private imgData: DroppedImage;
  private user: string;
  

  private isDragging = false;
  private dragOffsetX = 0;
  private dragOffsetY = 0;

  constructor(imageSrc: string, label: string, initialText: string, imgData: DroppedImage, user: string) {
    this.initialText = initialText;
    this.imgData = imgData;
    this.user = user;

    this.modal = document.createElement("div");
    this.modal.className = "comment-modal";

    const styleTag = document.createElement("style");
    styleTag.textContent = styles;
    this.modal.appendChild(styleTag);

    const title = document.createElement("div");
    title.draggable = false;
    title.addEventListener("mousedown", this.startDrag)
    this.modal.addEventListener("mousedown", this.startDrag)
    title.className = "comment-modal-title";
    title.textContent = label;
    this.modal.appendChild(title);

    const image = document.createElement("img");
    image.src = imageSrc;
    image.className = "comment-modal-image";
    this.modal.appendChild(image);

    this.textarea = document.createElement("textarea");
    this.textarea.className = "comment-modal-textarea";
    this.textarea.value = initialText;
    this.modal.appendChild(this.textarea);

    const buttonContainer = document.createElement("div");
    buttonContainer.className = "comment-modal-buttons";

    this.okButton = document.createElement("button");
    this.okButton.textContent = "OK";
    this.okButton.className = "comment-btn";
    this.okButton.disabled = true;
    this.okButton.classList.add("disabled");
    this.okButton.onclick = () => this.submit();
    this.textarea.addEventListener("input", () => {
      const hasChanges = this.textarea.value.trim() !== this.initialText.trim();
      this.okButton.disabled = !hasChanges;

      if (hasChanges) {
        this.okButton.classList.remove("disabled");
      } else {
        this.okButton.classList.add("disabled");
      }
    });

    const cancelButton = document.createElement("button");
    cancelButton.textContent = `${i18next.t("cancel")}`;
    cancelButton.className = "comment-btn cancel";
    cancelButton.onclick = () => this.close();

    buttonContainer.appendChild(this.okButton);
    buttonContainer.appendChild(cancelButton);
    this.modal.appendChild(buttonContainer);
    document.body.appendChild(this.modal);
  }

  private startDrag = (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if ((e.target as HTMLElement).closest(".comment-btn")) return;
    if (target.classList.contains("comment-modal-textarea")) return;
    if (target.classList.contains("comment-modal-image")) return;
    if (target.classList.contains("comment-modal-title")) return;

    const rect = this.modal.getBoundingClientRect();
    this.modal.style.transform = "none";
    this.modal.style.left = rect.left + "px";
    this.modal.style.top = rect.top + "px";

    this.isDragging = true;
    this.dragOffsetX = e.clientX - rect.left;
    this.dragOffsetY = e.clientY - rect.top;

    document.addEventListener("mousemove", this.onDrag);
    document.addEventListener("mouseup", this.stopDrag);
  };


  private onDrag = (e: MouseEvent) => {
    if (!this.isDragging) return;

    const x = e.clientX - this.dragOffsetX;
    const y = e.clientY - this.dragOffsetY;

    this.modal.style.left = x + "px";
    this.modal.style.top = y + "px";
  };

  private stopDrag = () => {
    this.isDragging = false;
    document.removeEventListener("mousemove", this.onDrag);
    document.removeEventListener("mouseup", this.stopDrag);
  };

  private submit() {
    const comment = this.textarea.value.trim();
    setImageComment(this.imgData, comment, this.user)
    this.close();
  }

  private close() {
    document.body.removeChild(this.modal);
  }
}